import React, { useContext, useEffect } from "react";
import { useQuery } from '@apollo/client';
import Encart from 'components/Encart';
import Anchor from 'components/Misc/Anchor';
import Queries from 'utils/Queries';
import { SettingsContext } from 'Providers/SettingsProvider';

function Contact() {
    const { refetch,networkStatus,data } = useQuery(Queries.contact);
    const { updateLoadState,fetchedList } = useContext(SettingsContext);
    const uuid='contact';
    useEffect(()=>updateLoadState(uuid,networkStatus),[networkStatus,updateLoadState,uuid]);
    useEffect(()=>{
      if(fetchedList.indexOf(uuid)===-1){
        console.log('fetch',uuid);
        refetch();
      }
    },[refetch,fetchedList,uuid]);
    const rub=data ? data.rubriques[0] : null;
    const dataContact={
        rub,
    }
    return data ? <>
        <Anchor slug={rub.slugs[0].slug} rubId={5}/>
        <Encart data={dataContact} template='contact'/>
    </> : '';
}

export default Contact;
